var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNextLarge = function SvgNextLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.962 6.145a.75.75 0 0 1 1.06-.016l9.626 9.333a.744.744 0 0 1 .194.33.746.746 0 0 1 .017.36.746.746 0 0 1-.212.387l-9.624 9.333a.75.75 0 0 1-1.046-1.077l8.296-8.045H6.875a.75.75 0 0 1 0-1.5h17.398l-8.296-8.045a.75.75 0 0 1-.015-1.06Z",
    fill: "#273943"
  })));
};
export default SvgNextLarge;